export default function createCollapsiblePalette(theme, current, base) {
    return {
        collapsible: {
            header: {
                disabled: {
                    color: base.text[300],
                },
            },
        },
    };
}
//# sourceMappingURL=collapsible.js.map